import { EDIT_GUEST } from '../actionTypes'

export const editGuest = (data: object) => ({
  type: EDIT_GUEST.name,
  api: {
    url: 'guests/update_guest',
    data,
  },
})
